/** Sort search folders by displayOrder ascending, then name. When ownerName is set, group by owner first. */
export function sortSearchFolders<
  T extends { displayOrder?: number | null; name: string; ownerName?: string | null },
>(folders: T[]): T[] {
  return [...folders].sort((a, b) => {
    const aOwner = a.ownerName?.trim() ?? '';
    const bOwner = b.ownerName?.trim() ?? '';
    if (aOwner || bOwner) {
      const ownerCmp = aOwner.localeCompare(bOwner, undefined, { sensitivity: 'base' });
      if (ownerCmp !== 0) return ownerCmp;
    }
    const ao = Number(a.displayOrder ?? 0);
    const bo = Number(b.displayOrder ?? 0);
    if (ao !== bo) return ao - bo;
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
  });
}
